var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.5,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.5",
    height: 37.5,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a166706538"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.988281 1.65625 L 35.8125 1.65625 L 35.8125 35.480469 L 1.988281 35.480469 Z M 1.988281 1.65625 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a166706538)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDF9",
    stroke: "#FDFDF9",
    strokeWidth: 1,
    d: "M 18.714844 35.113281 C 9.492188 35.113281 1.988281 27.605469 1.988281 18.382812 C 1.988281 9.160156 9.492188 1.65625 18.714844 1.65625 C 27.9375 1.65625 35.445312 9.160156 35.445312 18.382812 C 35.445312 27.605469 27.9375 35.113281 18.714844 35.113281 Z M 18.714844 3.046875 C 10.261719 3.046875 3.378906 9.929688 3.378906 18.382812 C 3.378906 26.835938 10.261719 33.71875 18.714844 33.71875 C 27.167969 33.71875 34.050781 26.835938 34.050781 18.382812 C 34.050781 9.929688 27.167969 3.046875 18.714844 3.046875 Z M 18.714844 3.046875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDF9",
    stroke: "#FDFDF9",
    strokeWidth: 1,
    d: "M 26.199219 25.351562 L 11.230469 25.351562 C 10.890625 25.351562 10.597656 25.109375 10.542969 24.773438 L 8.964844 15.480469 C 8.921875 15.21875 9.027344 14.960938 9.238281 14.804688 C 9.445312 14.648438 9.726562 14.617188 9.960938 14.738281 L 14.484375 16.96875 L 18.105469 10.378906 C 18.347656 9.9375 19.082031 9.9375 19.324219 10.378906 L 22.945312 16.96875 L 27.46875 14.738281 C 27.703125 14.617188 27.984375 14.648438 28.191406 14.804688 C 28.402344 14.960938 28.507812 15.222656 28.464844 15.480469 L 26.886719 24.773438 C 26.832031 25.109375 26.539062 25.351562 26.199219 25.351562 Z M 11.820312 23.960938 L 25.613281 23.960938 L 26.863281 16.589844 L 22.964844 18.511719 C 22.628906 18.679688 22.222656 18.550781 22.046875 18.222656 L 18.714844 12.164062 L 15.386719 18.222656 C 15.207031 18.550781 14.804688 18.679688 14.46875 18.511719 L 10.570312 16.589844 Z M 11.820312 23.960938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.99c7ccb25de7522a0e4bffa0264ba1a9.svg";
export { ForwardRef as ReactComponent };